import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  Row,
  Col,
  Table,
  Button,
} from 'reactstrap';
import { fetchCharacteristicsInitAction } from '../../../../../actions/instances/characteristics';
import Icon from '../../../../atoms/Icon/Icon';
import './SelectCharacteristicModal.scss';

const SelectCharacteristicModal = ({
  onItemSelected,
}) => {
  const {
    characteristics,
    didLoadCharacteristics,
    isLoadingCharacteristics,
  } = useSelector(state => state.characteristics);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!didLoadCharacteristics && !isLoadingCharacteristics) {
      dispatch(fetchCharacteristicsInitAction());
    }
  }, []);
  return (
    <div>
      <Row>
        <Col md={12}>
          <Table responsive striped bordered>
            <colgroup>
              <col width="10%" />
              <col width="60%" />
              <col width="20%" />
              <col width="10%" />
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Dynasty</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {characteristics.map(char => (
                <tr>
                  <td>{char.code}</td>
                  <td>{`${char.name} [${char.code}]`}</td>
                  <td>{`${char.dynasty.name} [${char.dynasty.code}]`}</td>
                  <td className="text-center">
                    <Button size="sm" color="light" onClick={() => onItemSelected(char)}>
                      <Icon icon="check" color="#000" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
};

SelectCharacteristicModal.propTypes = {
  onItemSelected: PropTypes.func.isRequired,
};

SelectCharacteristicModal.defaultProps = {

};

export default SelectCharacteristicModal;
